import classNames from 'classnames';
import styles from './ChangeAssessmentAnswersModal.module.scss';
import { Button } from '../common/Button';
import { ModalOverlay } from '../ModalOverlay';
import { AssessmentInviteForm } from '../AssessmentInviteForm';
import { useEffect, useState } from 'react';
import { QuestionList } from '../../assessment/components/QuestionList';
import { useLazyQuery } from '@apollo/react-hooks';
import { ASSESSMENT_ANSWERS, ASSESSMENT_QUESTIONS } from '../../apollo/queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';
// @ts-ignore
library.add(faSpinner)


interface ChangeAssessmentAnswersModalInput {
    assessmentUuid: string | null
    button?: boolean
    isOpen: boolean,
    version?: Number
    onOpenChange: Function
    getUpdatedAnswers: Function
    counts?: {
        questionCount: number,
        answerCount: number
    } | null
}

export const ChangeAssessmentAnswersModal = ({
    assessmentUuid,
    onOpenChange,
    isOpen = false,
    version = 0,
    getUpdatedAnswers,
    counts
}: ChangeAssessmentAnswersModalInput) => {
    // const [isOpen, setIsOpen] = useState(false);
    const [sendingSuccessful, setSendingSuccessful] = useState(false);
    const [errorFound, setErrorFound] = useState(false);
    const [isSavingAnswers, setIsSavingAnswers] = useState(false);

    const [answers, setAnswers] = useState<[any] | boolean>(false)
    const [updatedAnswers, setUpdatedAnswers] = useState(null)
    const [questions, setQuestions] = useState(false)

    const [getAnswers] = useLazyQuery(ASSESSMENT_ANSWERS)
    const [getQuestions] = useLazyQuery(ASSESSMENT_QUESTIONS)

    useEffect(() => {
        console.log('useEffect', {assessmentUuid, isOpen})
        if(assessmentUuid && isOpen) {
            (async() => {
                await getQuestionsAndAnswers(assessmentUuid, version)
            })()
        }
    }, [assessmentUuid, version, isOpen])

    const getQuestionsAndAnswers = async (uuid: string, version: Number) => {
        console.log('updating questions and answers')
        const aResult = await getAnswers({
            variables: {
                uuid: uuid,
                version
            },
            fetchPolicy: 'network-only'
        })
        const answers = aResult.data?.assessmentAnswers?.answers
        const qResult = await getQuestions({
            variables: {
                uuid: uuid
            },
            fetchPolicy: 'network-only'
        })
        const questions = qResult.data.assessmentQuestions
        setQuestions(questions)
        setAnswers(answers)
    }

    const handleSaveAnswers = (answers: [any]) => {
        console.log({handleSaveAnswers: answers})
        if(answers !== null) {
            // @ts-ignore
            setUpdatedAnswers(answers)
        }
    }

    const handleOpenSend = () => {
        setQuestions(false)
        setAnswers(false)
        setIsSavingAnswers(false)
        onOpenChange(!isOpen);
    };


    return (
        <div className={classNames(styles.wrapper, styles.buttonWrapper)}>
            <ModalOverlay show={isOpen}>
                    <div className={styles.header}>
                        <p className={styles.subtitle}>
                            Assessment Answers
                        </p>
                        <button className={styles.close} onClick={() => handleOpenSend()}>
                            X
                        </button>
                    </div>
                    <section className={styles.questionListWrapper}>
                        { questions && answers &&
                            <QuestionList questions={questions} answers={answers} getUpdatedAnswers={handleSaveAnswers} reviewMode={true} />
                        }
                    </section>
                    {counts && counts.answerCount < counts.questionCount &&
                        <div className={styles.error}>Number of answers ({counts?.answerCount}) do not match number of questions ({counts?.questionCount})</div>
                    }
                    <div className={classNames(styles.buttons, styles.modalButtons)}>
                        {isSavingAnswers &&
                            <span className={styles.icon}>
                                <FontAwesomeIcon icon='spinner' className="spinner"></FontAwesomeIcon>
                                Rendering PDF...
                            </span>
                        }
                        {!isSavingAnswers &&
                            <>
                                <button
                                    className={styles.delete}
                                    onClick={async () => {
                                        setIsSavingAnswers(true)
                                        console.log('On click ', {answers, updatedAnswers})
                                        if(updatedAnswers) {
                                            await getUpdatedAnswers(updatedAnswers)
                                        } else if(typeof answers !== 'boolean') {
                                            await getUpdatedAnswers(answers)
                                        }
                                        // setQuestions(false)
                                        // setAnswers(false)
                                        setIsSavingAnswers(false)
                                    }}
                                >
                                    Opslaan
                                </button>

                                <button className={styles.cancel} onClick={() => handleOpenSend()}>
                                    Annuleren
                                </button>
                            </>
                        }
                    </div>
            </ModalOverlay>
        </div>
    );
};
